export default __webpack_public_path__ + "static/girlLaptop-260a127c0cb7bb27bdc380b03d047daa.svg";